import React from 'react';
import PropTypes from 'prop-types';
const Moment = require('moment');
import { Row } from 'react-bootstrap';
const uuid = require('uuid');

const Strings = require('../../../../app/shared/Strings');
const ActivityActions = require('../../actions/ActivityActions');
const TemplateStore = require('../../stores/template_store_reflux');
import DateString from '../common/DateString';
import UserDisplayName from '../user/UserDisplayName';
import StatTile from '../tiles/StatTile';
import WithActivityData from '../DataHOCs/WithActivityData';

const propTypes = {
    activityId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    activityStoreState: PropTypes.object.isRequired,
    className: PropTypes.string,
};

const defaultProps = {
    className: ''
};

class ActivityDetails extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            templateStoreState: TemplateStore.getState(),
        };

        this.refreshActivitySaves = this.refreshActivitySaves.bind(this);
        this.unsubscribes = [TemplateStore.listen(this.onStoreChange.bind(this, "templateStoreState"))];
    }

    componentDidMount() {
        this.refreshActivitySaves(this.props.activityId);
    }

    componentDidUpdate(prevProps) {
        // TODO: this will be true twice during switch from parent component
        if (this.props.activityId !== prevProps.activityId) {
            this.refreshActivitySaves(this.props.activityId);
        }
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }

    refreshActivitySaves(activityId) {
        ActivityActions.getActivitySaves(uuid.v4(), { activityId: activityId });
    }

    onStoreChange(storeStateName, state) {
        this.setState({ [storeStateName]: state });
    }

    render() {
        if (
            !this.props.activityStoreState.initialized
            || !this.state.templateStoreState.initialized
        ) {
            return null;
        }

        const activity = this.props.activityStoreState.activity;
        if (!activity) {
            console.warn(`Activity ${this.props.activityId} not found in store.`);
            return null;
        }

        let lastPublishedDate = 0; // moment eqiv. for epoch time
        let foundLastPublished = false;
        if (this.props.activityStoreState.activitySaves) {
            this.props.activityStoreState.activitySaves.forEach(save => {
                if (save.published_on && Moment(save.published_on) > Moment(lastPublishedDate)) {
                    foundLastPublished = true;
                    lastPublishedDate = save.saved_at;
                }
            });
        }

        let templateName = '';
        const template = TemplateStore.getTemplateForProduct(activity.product);
        if(template) {
            templateName = template.name;
        }
        else {
            console.warn(`ActivityDetails: Template for ${activity.product} not in store.`);
        }

        return (
            <Row className={`${this.props.className}`}>
                <StatTile
                    className="text-centered border-right col-6 col-sm-4 col-lg-2"
                    term={Strings['en'].activity.TEMPLATE}
                >
                    {templateName}
                </StatTile>
                <StatTile
                    className="text-centered border-right col-6 col-sm-4 col-lg-2"
                    term={Strings['en'].common.CREATED}
                >
                    <DateString shortMonth date={activity.created_at} />
                </StatTile>
                <StatTile
                    className="text-centered border-right col-6 col-sm-4 col-lg-2"
                    term={Strings['en'].common.MODIFIED}
                >
                    <DateString shortMonth date={activity.modified} />
                </StatTile>
                <StatTile
                    className="text-centered border-right col-6 col-sm-4 col-lg-2"
                    term={Strings['en'].activity.LAST_PUBLISHED}
                >
                    { foundLastPublished ?
                        <DateString shortMonth date={lastPublishedDate} />
                        :
                        Strings['en'].common.NEVER
                    }
                </StatTile>
                <StatTile
                    className="text-centered border-right col-6 col-sm-4 col-lg-2"
                    term={Strings['en'].common.AUTHOR}
                >
                    <UserDisplayName id={activity.owner_id} />
                </StatTile>
                <StatTile
                    className="text-centered border-right col-6 col-sm-4 col-lg-2"
                    term={Strings['en'].activity.CURRENT_VERSION}
                >
                    {activity.version}
                </StatTile>
            </Row>
        )
    }
}

ActivityDetails.propTypes = propTypes;
ActivityDetails.defaultProps = defaultProps;

export default WithActivityData(ActivityDetails);